import { NgModule } from '@angular/core';
import { FilterBoxComponent } from './form-inputs/filter-box/filter-box.component';
import { TextBoxComponent } from './form-inputs/text-box/text-box.component';
import { NumberBoxComponent } from './form-inputs/number-box/number-box.component';
import { CheckBoxComponent } from './form-inputs/check-box/check-box.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TopBarComponent } from './layouts/top-bar/top-bar.component';
import { FooterComponent } from './layouts/footer/footer.component';
import { SidebarComponent } from './layouts/sidebar/sidebar.component';
import { MainmenuComponent } from './menus/mainmenu/mainmenu.component';
import { ThumbnailComponent } from './menus/thumbnail/thumbnail.component';
import { SearchButtonComponent } from './buttons/search-button/search-button.component';
import { ModalComponent } from './communication/modal/modal.component';
import { AuthLinksComponent } from './authentification/auth-links/auth-links.component';
import { LibCoreSharedModule } from 'lib-core-shared';
import { CMPaginationComponent } from './result/cm-pagination/cm-pagination.component';
import { SelectBoxComponent } from './form-inputs/select-box/select-box.component';
import { RadioListBoxComponent } from './form-inputs/radio-list-box/radio-list-box.component';
import { LibTabsComponent } from './lib-tabs/lib-tabs.component';
import { TextAreaComponent } from './form-inputs/text-area/text-area.component';
import { ControlLayoutComponent } from './form-inputs/control-layout/control-layout.component';
import { AddressComponent } from './particulars/address/address.component';
import { AddressSearchBoxComponent } from './address-search-box/address-search-box.component';
import { SearchLocationComponent } from './search-location/search-location.component';
import { AddressSuggestionOptionsComponent } from './address-search-box/presentation/address-suggestion-options/address-suggestion-options.component';
import { AddressRetryContinueOptionsComponent } from './address-search-box/presentation/address-retry-continue-options/address-retry-continue-options.component';
import { CustomerSummaryComponent } from './customer-summary/customer-summary.component';
import { CommonModule } from '@angular/common';
import { PageBaseDirective } from './directives/page-base.directive';
import { ComponentBaseDirective } from './directives/component.directive';
import { ControlBaseDirective } from './directives/control-base.directive';
import { CheckBoxReadonlyComponent } from './check-box-readonly/check-box-readonly.component';
import { DisableControlDirective } from './directives/disabled.directive';
import { MultiTypePageBaseDirective } from './directives/multtype-page-base.directive';
import { SmartViewComponent } from './layouts/smart-view/smart-view.component';
import { DatePickerComponent } from './form-inputs/date-picker/date-picker.component';
import { RequiredFieldsComponent } from './form-guidance/required-fields/required-fields.component';
import { SupersedeProductComponent } from './product/supersede-product/supersede-product.component';
import { ProductSummaryComponent } from './product/product-summary/product-summary.component';
import { ProductMasterStatusPillComponent } from './product-master-status-pill/product-master-status.component';
import { TextBoxWithDropdownComponent } from './form-inputs/text-box-with-dropdown/text-box-with-dropdown.component';
import { FilePickerBoxComponent } from './form-inputs/file-picker-box/file-picker-box.component';
import { StockStatusIndicatorComponent } from './stock-status-indicator/stock-status-indicator.component';
import { ResolveCustomerAddressComponent } from './missing-customer-information/resolve-customer-address/resolve-customer-address.component';
import { ResolveCustomerContactComponent } from './missing-customer-information/resolve-customer-contact/resolve-customer-contact.component';
import { PhoneNumberInputComponent } from './form-inputs/phone-number/phone-number-input.component';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient } from '@angular/common/http';
import { DuplicateEmailCheckComponent } from './duplicate-email-check/duplicate-email-check.component';
import { ProductTypeIndicatorComponent } from './indicators/product-type/product-type-indicator.component';
import { TreeNodesComponent } from './tree-nodes/tree-nodes.component';
import { ModalTypeInputComponent } from './form-inputs/modal-type-input/modal-type-input.component';
import { ProductTagComponent } from './product-tag/product-tag.component';
import { ProductTagSearchComponent } from './product-tag-search/product-tag-search.component';
import { CreateProductTagComponent } from './product-tag-search/containers/create/create-product-tag.component';
import { EditProductTagComponent } from './product-tag-search/containers/edit/edit-product-tag.component';
import { RouterModule } from '@angular/router';

export function HttpLoaderFactory(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient, './assets/i18n/', '.json');
}
@NgModule({
  imports: [
    CommonModule,
    NgbModule,
    FormsModule,
    ReactiveFormsModule,
    LibCoreSharedModule,
    TranslateModule.forChild({
      defaultLanguage: 'en',
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
      isolate: true,
    }),
    RouterModule
  ],
  declarations: [
    CheckBoxReadonlyComponent,
    ControlBaseDirective,
    FilterBoxComponent,
    TextBoxComponent,
    SelectBoxComponent,
    CheckBoxComponent,
    DisableControlDirective,
    PageBaseDirective,
    MultiTypePageBaseDirective,
    ComponentBaseDirective,
    TopBarComponent,
    FooterComponent,
    SidebarComponent,
    MainmenuComponent,
    ThumbnailComponent,
    SearchButtonComponent,
    ModalComponent,
    AuthLinksComponent,
    NumberBoxComponent,
    CMPaginationComponent,
    RadioListBoxComponent,
    LibTabsComponent,
    TextAreaComponent,
    ControlLayoutComponent,
    AddressComponent,
    AddressSearchBoxComponent,
    SearchLocationComponent,
    AddressSuggestionOptionsComponent,
    AddressRetryContinueOptionsComponent,
    CustomerSummaryComponent,
    SmartViewComponent,
    DatePickerComponent,
    RequiredFieldsComponent,
    ProductSummaryComponent,
    SupersedeProductComponent,
    ProductMasterStatusPillComponent,
    TextBoxWithDropdownComponent,
    FilePickerBoxComponent,
    StockStatusIndicatorComponent,
    ResolveCustomerAddressComponent,
    ResolveCustomerContactComponent,
    PhoneNumberInputComponent,
    DuplicateEmailCheckComponent,
    ProductTypeIndicatorComponent,
    ModalTypeInputComponent,
    TreeNodesComponent,
    ProductTagComponent,
    ProductTagSearchComponent,
    CreateProductTagComponent,
    EditProductTagComponent
  ],
  entryComponents: [
    CheckBoxReadonlyComponent,
    ControlBaseDirective,
    FilterBoxComponent,
    PageBaseDirective,
    MultiTypePageBaseDirective,
    ComponentBaseDirective,
    TextBoxComponent,
    CheckBoxComponent,
    SelectBoxComponent,
    RadioListBoxComponent,
    TopBarComponent,
    NumberBoxComponent,
    DisableControlDirective,
    CMPaginationComponent,
    LibTabsComponent,
    TextAreaComponent,
    ControlLayoutComponent,
    AddressComponent,
    AddressSearchBoxComponent,
    SearchLocationComponent,
    AddressSuggestionOptionsComponent,
    AddressRetryContinueOptionsComponent,
    CustomerSummaryComponent,
    SmartViewComponent,
    DatePickerComponent,
    RequiredFieldsComponent,
    ProductSummaryComponent,
    SupersedeProductComponent,
    TextBoxWithDropdownComponent,
    FilePickerBoxComponent,
    ResolveCustomerAddressComponent,
    ResolveCustomerContactComponent,
    PhoneNumberInputComponent,
    DuplicateEmailCheckComponent,
    ProductTypeIndicatorComponent,
    TreeNodesComponent,
    ModalTypeInputComponent
  ],
  exports: [
    CheckBoxReadonlyComponent,
    ControlBaseDirective,
    MultiTypePageBaseDirective,
    FilterBoxComponent,
    FooterComponent,
    TextBoxComponent,
    CheckBoxComponent,
    SelectBoxComponent,
    RadioListBoxComponent,
    TopBarComponent,
    DisableControlDirective,
    NumberBoxComponent,
    CMPaginationComponent,
    LibTabsComponent,
    TextAreaComponent,
    ControlLayoutComponent,
    AddressComponent,
    AddressSearchBoxComponent,
    SearchLocationComponent,
    CustomerSummaryComponent,
    SmartViewComponent,
    DatePickerComponent,
    RequiredFieldsComponent,
    ProductSummaryComponent,
    SupersedeProductComponent,
    TextBoxWithDropdownComponent,
    FilePickerBoxComponent,
    ResolveCustomerAddressComponent,
    ResolveCustomerContactComponent,
    PhoneNumberInputComponent,
    DuplicateEmailCheckComponent,
    ProductTypeIndicatorComponent,
    TreeNodesComponent,
    ModalTypeInputComponent,
    ProductMasterStatusPillComponent,
    ProductTagComponent,
    ProductTagSearchComponent,
    CreateProductTagComponent,
    EditProductTagComponent
  ],
})
export class LibUiSharedModule {}
